import autobind from 'autobind-decorator';
import React from "react";

import { BoxView } from "common/views/box/Box.view";
import { CardView } from 'common/views/card/Card.view';
import HeadingView from 'common/views/heading/Heading.view';
import IconView from 'common/views/icon/Icon.view';
import { ImageView } from "common/views/image/Image.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IQueryOne, QueryOne } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import Config from "./Config";
import OrganizationUserlist from "./entities/OrganizationUserlist";


@Panel({id: "organizations-admin-userlist", configClass: Config, pageParams: true})
@QueryOne(OrganizationUserlist, {}, true)
export default class OrganizationsUsers extends React.PureComponent<IPanelProps<Config> & IQueryOne<OrganizationUserlist>> {

	@autobind
	public getQueryParams(): object {
		return {guid: this.props.pageParams.guid};
	}

	public render() {
		const { config, entity } = this.props;
		const userCards = (entity && entity.userList) && this.props.entity.userList.map((user, index) => {

		const src: string = user.avatar && user.avatar.file && user.avatar.file.url;

		const leftIconView = src && (
			<ImageView src={src} viewKey="avatar-thumbnail" />
		);

		const nameView = (
			<HeadingView viewKey="name">{user.firstName} {user.lastName}</HeadingView>
		);

		const emailView = (<IconView icon="envelope" viewKey="faEmail">{user.email}</IconView>);

		return(
		<CardView viewKey="list-body" key={index}>
			{leftIconView}
			<div>
				{nameView}
				{emailView}
			</div>
		</CardView>
		);
	});

		return (

			<BoxView title={config.title} viewKey="organization-userlist-box">
				<RowsView viewKey="organization-userlist-rows">
					{userCards}
				</RowsView>
			</BoxView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/OrganizationUsers.panel.tsx